import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  LayoutDashboard, DollarSign, Users, School, FileText,
  ClipboardList, Wallet, MapPin, LogOut, Sparkles,
} from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/owner", label: "Executive", icon: LayoutDashboard, end: true, testId: "nav-owner-dashboard" },
  { to: "/owner/finance", label: "Financial", icon: DollarSign, testId: "nav-owner-finance" },
  { to: "/owner/crm", label: "CRM", icon: Users, testId: "nav-owner-crm" },
  { to: "/owner/communities", label: "Communities", icon: School, testId: "nav-owner-communities" },
  { to: "/owner/contracts", label: "Contracts", icon: FileText, testId: "nav-owner-contracts" },
  { to: "/owner/proposals", label: "Proposals", icon: ClipboardList, testId: "nav-owner-proposals" },
  { to: "/owner/payroll", label: "Payroll", icon: Wallet, testId: "nav-owner-payroll" },
  { to: "/owner/routes", label: "Routes", icon: MapPin, testId: "nav-owner-routes" },
];

export default function OwnerLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-[calc(100vh-64px)] flex bg-muted/20">
      <aside className="w-60 shrink-0 bg-primary text-primary-foreground p-4 flex flex-col gap-1 min-h-[calc(100vh-64px)]">
        <div className="mb-5">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center"><Sparkles size={14} /></div>
            <div>
              <div className="font-display font-semibold text-sm">Owner Portal</div>
              <div className="text-[10px] text-white/60 uppercase tracking-widest">Operations</div>
            </div>
          </div>
        </div>
        {NAV.map((n) => (
          <NavLink
            key={n.to} to={n.to} end={n.end} data-testid={n.testId}
            className={({ isActive }) =>
              `flex items-center gap-2 text-sm px-3 py-2 rounded-lg transition-colors ${
                isActive ? "bg-white/15 text-white font-semibold" : "text-white/70 hover:bg-white/5 hover:text-white"
              }`
            }
          >
            <n.icon size={16} strokeWidth={1.75} /> {n.label}
          </NavLink>
        ))}
        <div className="mt-auto pt-4 border-t border-white/10">
          <div className="text-xs text-white/60 mb-2">{user?.name}</div>
          <Button size="sm" variant="ghost" className="text-white/80 hover:text-white hover:bg-white/10 w-full justify-start"
                  onClick={async () => { await logout(); navigate("/"); }} data-testid="owner-logout">
            <LogOut size={14} className="mr-2" /> Sign out
          </Button>
        </div>
      </aside>
      <main className="flex-1 p-8 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
